@if (loader.message) {
  <div class="loader-class">
    <mat-spinner color="primary"></mat-spinner>
    <div class="loader-message">{{loader.message}}</div>
  </div>
}
@if (errorMessage) {
  <div class="error-container">
    <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
    <div class="loader-message">{{errorMessage}}</div>
  </div>
}
@if (!errorMessage && !loader.isLoading && entryDetails != null) {
  <div class="entry-page">
    <section class="hero-shell mat-elevation-z2" id="entry-top">
      <div class="hero-summary">
        <h1 class="hero-title">{{entryDetails.title}}</h1>
        <div class="meta-row">
          <span class="meta-pill"><mat-icon>person</mat-icon>{{entryDetails.tm_name}}</span>
          <span class="meta-pill"><mat-icon>calendar_month</mat-icon>{{entryDetails.date}}</span>
          <span class="meta-pill"><mat-icon>apartment</mat-icon>{{entryDetails.company_code}} / {{entryDetails.plant_name}}</span>
          <span class="meta-pill"><mat-icon>factory</mat-icon>{{entryDetails.shop_name}}</span>
        </div>
      </div>
      <div class="action-cluster">
        <button class="action-button secondary" mat-raised-button (click)="onBack()" 
          [disabled]="loader.isLoading || powerPointExportData?.exportInitiated" title="Back to Entries">
          All Entries
        </button>
        <button class="action-button warn" mat-raised-button color="accent" (click)="onEdit()"
          [disabled]="loader.isLoading || powerPointExportData?.exportInitiated" title="Edit Entry">
          Edit
        </button>
        <button class="action-button danger" mat-raised-button color="warn" (click)="onDelete()"
          [disabled]="loader.isLoading || powerPointExportData?.exportInitiated" title="Delete Entry">
          Delete
        </button>
        <button class="action-button" mat-raised-button color="primary" (click)="initiateExport()"
          [disabled]="loader.isLoading || powerPointExportData?.exportInitiated || !imagesContainer || imagesContainer?.loader.isLoading ||
          (costCalculationPayload != null && (!costCalculator || costCalculator?.loader.isLoading))" 
          title="Export Entry to PowerPoint">
          Export to PowerPoint
        </button>
      </div>
    </section>
    <section id="entry-overview" class="display-grid fields-display-container">
      <div class="field-wrapper display-field span3">
        <span class="field-label">TM Name</span>
        <div class="field-container mat-elevation-z1">
          <mat-icon class="field-icon">person</mat-icon>
          <span class="field-text" matTooltip="{{entryDetails.tm_name}}" matTooltipClass="wide-tooltip">{{entryDetails.tm_name}}</span>
        </div>
      </div>
      <div class="field-wrapper display-field span9">
        <span class="field-label">Title</span>
        <div class="field-container mat-elevation-z1">
          <span class="field-text-long">{{entryDetails.title}}</span>
        </div>
      </div>
      @if (contributorsList?.length > 0) {
        <div class="field-wrapper display-field full-width">
          <span class="field-label">Contributors</span>
          <div class="field-container mat-elevation-z1">
            @for (contributor of contributorsList; let i = $index; track contributor.email) {
              <mat-icon class="field-icon">person</mat-icon>
              <span class="contributor-field-text" matTooltip="{{contributor.email}}" matTooltipClass="wide-tooltip">
                {{ contributor.displayName }}
              </span>
              @if (i < contributorsList.length - 1) {
                <div class="contributor-divider"></div>
              }
            }
          </div>
        </div>
      }
      <div class="field-wrapper display-field span3">
        <span class="field-label">Date</span>
        <div class="field-container mat-elevation-z1">
          <mat-icon class="field-icon">calendar_month</mat-icon>
          <span class="field-text">{{entryDetails.date}}</span>
        </div>
      </div>
      <div class="field-wrapper display-field span3">
        <span class="field-label">Company</span>
        <div class="field-container mat-elevation-z1">
          <mat-icon class="field-icon">apartment</mat-icon>
          <span class="field-text" matTooltip="{{entryDetails.company_name}}" matTooltipClass="wide-tooltip">
            {{entryDetails.company_code}}
          </span>
        </div>
      </div>
      <div class="field-wrapper display-field span3">
        <span class="field-label">Plant</span>
        <div class="field-container mat-elevation-z1">
          <mat-icon class="field-icon">apartment</mat-icon>
          <span class="field-text" [class.field-small-font]="entryDetails.plant_name.length > 25"
            matTooltip="{{entryDetails.plant_name}}" matTooltipClass="wide-tooltip">
            {{entryDetails.plant_name}}
          </span>
        </div>
      </div>
      <div class="field-wrapper display-field span3">
        <span class="field-label">Shop</span>
        <div class="field-container mat-elevation-z1">
          <mat-icon class="field-icon">apartment</mat-icon>
          <span class="field-text" [class.field-small-font]="entryDetails.shop_name.length > 25"
            matTooltip="{{entryDetails.shop_name}}" matTooltipClass="wide-tooltip">
            {{entryDetails.shop_name}}
          </span>
        </div>
      </div>
      <div class="narrative-stack full-width">
        <div class="narrative-card mat-elevation-z1">
          <span class="narrative-label">Description</span>
          <div class="narrative-content" [innerHTML]="entryDetails.issues"></div>
        </div>
        <div class="narrative-card mat-elevation-z1">
          <span class="narrative-label">Actions/Steps Taken</span>
          <div class="narrative-content" [innerHTML]="entryDetails.actions"></div>
        </div>
        <div class="narrative-card mat-elevation-z1">
          <span class="narrative-label">Improvements/Outcomes</span>
          <div class="narrative-content" [innerHTML]="entryDetails.outcomes"></div>
        </div>
      </div>
      @if (entryDetails.maximo_workorder_link) {
        <div class="field-wrapper display-field">
          <span class="field-label">Maximo Work Order Link</span>
          <div class="field-container mat-elevation-z1 padding-sides">
            <span class="field-text">{{entryDetails.maximo_workorder_link}}</span>
            <mat-icon class="field-icon pointer" (click)="copyLink(entryDetails.maximo_workorder_link)"
              matTooltip="Copy" matTooltipClass="wide-tooltip">content_copy
            </mat-icon>
            <mat-icon class="field-icon pointer" (click)="window.open(entryDetails.maximo_workorder_link, '_blank')"
              matTooltip="Open" matTooltipClass="wide-tooltip">open_in_new
            </mat-icon>
          </div>
        </div>
      }
      @if (entryDetails.edc_link) {
        <div class="field-wrapper display-field">
          <span class="field-label">EDC Reference Link</span>
          <div class="field-container mat-elevation-z1 padding-sides">
            <span class="field-text">{{entryDetails.edc_link}}</span>
            <mat-icon class="field-icon pointer" (click)="copyLink(entryDetails.edc_link)"
              matTooltip="Copy" matTooltipClass="wide-tooltip">content_copy
            </mat-icon>
            <mat-icon class="field-icon pointer" (click)="window.open(entryDetails.edc_link, '_blank')"
              matTooltip="Open" matTooltipClass="wide-tooltip">open_in_new
            </mat-icon>
          </div>
        </div>
      }
      @if (entryDetails.asset_id) {
        <div class="field-wrapper display-field">
          <span class="field-label">Maximo Asset Id</span>
          <div class="field-container mat-elevation-z1">
            <span class="field-text">{{entryDetails.asset_id}}</span>
          </div>
        </div>
      }
    </section>
    <section id="entry-categories">
      @for (category of entryDetails.operationalFocusCategories; track category) {
        @if (category.displayFields.length > 0 && category.selected) {
          <div class="display-grid fields-display-container-operational" [attr.id]="'category-' + category.name">
            <div class="category-info display-field full-width">
              <div class="operational-focus-emoji" [attr.aria-label]="category.displayName" role="img">
                {{ category.glyph }}
              </div>
              <div class="category-header"
                [class.category-header-compact]="category.name === 'productivity' && !entryDetails.data_type">
                {{category.headerName}}
              </div>
              @if (category.name === 'productivity' && !entryDetails.data_type) {
                <span class="calc-mode-badge" title="Downtime calculation mode">Mode: {{downtimeMode}}</span>
              }
            </div>
            <div class="vertical-divider"></div>
            @if (category.name === 'productivity' && costCalculationPayload != null) {
              <div class="full-width">
                <app-cost-calculator #calculator [inputPayload]="costCalculationPayload"></app-cost-calculator>
              </div>
            }
            @for (displayField of category.displayFields; track displayField) {
              <div class="field-wrapper" [style.grid-column]="`span ${12 / category.displayFields.length}`">
                <span class="field-label">{{displayField.label}}</span>
                @if (category.name === 'productivity') {
                  <div class="field-container mat-elevation-z1">
                    <span class="field-text" [matTooltip]="displayField.label" matTooltipClass="wide-tooltip">
                      {{ displayField.prefix ?? '' }} {{ entryDetails[displayField.field] }}
                    </span>
                  </div>
                }
                @else {
                  <textarea disabled id="category-text-field" class="description-field mat-elevation-z1">
                    {{ displayField.prefix ?? '' }} {{ entryDetails[displayField.field] }}
                  </textarea>
                }
              </div>
            }
          </div>
        }
      }
    </section>
    <section id="entry-documents" class="image-container">
      <app-upload-documents #images_container [inputPayload]="imagesAndDocumentsPayload"></app-upload-documents>
    </section>
  </div>
}
<!-- Defer this block to load only when user clicks export button -->
@defer (when powerPointExportData?.exportInitiated) {
  @if (powerPointExportData?.exportInitiated) {
    <app-export-powerpoint [powerPointExportData]="powerPointExportData"
      (exportCompleted)="onExportCompleted($event)">
    </app-export-powerpoint>
  }
}
@loading {
  <div class="loader-class">
    <mat-spinner color="primary"></mat-spinner>
    <div class="loader-message">Exporting Success Entry to PowerPoint...</div>
  </div>
}